<template>
  <Modal
    v-model="modal"
    :closable="false"
    footer-hide
    class-name="payroll-modal"
    :mask-closable="false"
    :width="375"
  >
    <Spin size="large" fix v-if="loading"></Spin>

    <div v-else class="bg-grey">
      <div class="payroll-modal-warp-bg">
        <div class="payroll-modal-warp-bg-image">
          <img src="@/assets/img/payrollBg.png" alt="payrollBg" />
        </div>
        <div class="payroll-modal-warp-bg-row">
          <div class="close-btn" @click="modal = false">
            <Icon
              :size="22"
              style="cursor: pointer"
              color="#fff"
              type="md-close"
            />
          </div>
          <div class="info">
            <div class="actualAmount">
              {{ $t('payroll.detail.actualAmount') }}
              <div @click="onShowEye()">
                <Icon
                  :size="26"
                  color="#fff"
                  :type="isEye ? 'ios-eye-outline' : 'ios-eye-off-outline'"
                />
              </div>
            </div>
            <div class="actualSalary">
              <span class="amount">
                {{ getShowSalary('actualSalary') }}
              </span>
            </div>
            <div v-if="detail.paymentDate">
              {{ $t('payroll.list.paymentDate') }}：{{ detail.paymentDate }}
            </div>
            <div v-if="detail.confirmedAt">
              {{ $t('payroll.detail.confirmedAt') }}：{{
                $moment(
                  detail.confirmedAt1
                    ? detail.confirmedAt1
                    : detail.confirmedAt + 'Z'
                ).format('YYYY-MM-DD HH:mm')
              }}
            </div>
            <div v-if="detail.startDate">
              {{ $t('payroll.list.cycle') }}: {{ detail.startDate }} ~
              {{ detail.endDate }}
            </div>
            <div v-if="detail.confirmedAt" class="confirmed-position">
              <img
                :src="getConfirmedImg()"
                class="confirmed-image"
                alt="confirmed"
              ></img>
            </div>
          </div>
          <div class="bottom">
            <div>
              {{ $t('payroll.detail.expectSalary') }}：{{
                getShowSalary('expectSalary')
              }}
            </div>
            <div>
              {{ $t('payroll.detail.attendanceDebit') }}：{{
                getShowSalary('attendanceDebit')
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="payroll-modal-content">
        <div class="payroll-header">
          <span class="title">
            {{ $t('payroll.detail.payrollConfirmationPayslipItems') }}
              <Tooltip :max-width="250" placement="top" :content="$t('payroll.detail.tip')">
                 <Icon type="ios-information-circle-outline" />
              </Tooltip>
          </span>
          <div class="payroll-header-action">
            <div class="download action" @click="onDownPayroll()">
              <Icon :size="16" type="ios-download-outline" />
              {{$t('payroll.detail.down')}}
            </div>
            <FeedbackPoptip
              :payrollConfirmationComments="detail.payrollConfirmationComments"
              :payrollConfirmationId="detail.payrollConfirmation.id"
            ></FeedbackPoptip>
          </div>
        </div>
        <perfect-scrollbar>
          <div class="payroll-items">
            <div
              class="item"
              v-for="(v, i) in detail.payrollConfirmationPayslipItems"
              :key="`salaryType${i}`"
            >
              <label>{{ v.name }}</label>
              <span>{{ !isEye ? '****' : onToLocaleString(v.amount) }}</span>
            </div>
            <!--备注-->
            <div class="item">
              <label>{{ $t('payroll.detail.remark') }}</label>
              <span>{{ detail.remark }}</span>
            </div>
          </div>
        </perfect-scrollbar>
        <div class="payroll-footer" v-if="!detail.confirmedAt && !loading">
          <div class="payroll-footer-box">
            <Button
              @click="onConfirm"
              :loading="sbLoading"
              long
              size="large"
              type="primary"
            >
              {{ $t('payroll.detail.sb_payslips') }}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'vuex';
import FeedbackPoptip from './FeedbackPoptip.vue';
import currencyToAreaCode from "@/assets/js/currency-to-area-code";

export default {
  name: 'PayrollDetailModal',
  components: { FeedbackPoptip },
  computed: {
    ...mapState({
      countryCode: state => state.team.country.code,
    })
  },
  data() {
    return {
      modal: false,
      isEye: false,
      sbLoading: false,
      downLoading: false,
      loading: false,
      detail: {
        id: null,
        payrollConfirmation:{id:null},
        payrollConfirmationPayslipItems: [],
        payrollConfirmationComments: []
      }
    };
  },
  methods: {
    onOpen(id) {
      this.modal = true;
      this.initPayroll(id);
    },
    //详情数据
    async initPayroll(id) {

      try {
        this.loading = true;
        const { data } = await this.$http(
          'get',
          `mobile/payroll_confirmations/${id}`,
          {},
          true
        );

        const isMalaysia = currencyToAreaCode[this.countryCode] === 'MY';
        if (this.countryCode === "CHN" || isMalaysia) {
          data.payrollConfirmationPayslipItems.push({
            salaryTypeCode:'PERSONAL_INCOME_TAX',
            name: this.$t(`payroll.detail.${!isMalaysia?'personalIncomeTax':'personalIncomeTaxMYS'}`),
            amount: data.personalIncomeTax,
          });
        }

        if (!data.showEmptyItemFlag) {
          data.payrollConfirmationPayslipItems = _.filter(
            data.payrollConfirmationPayslipItems,
            (v) => {
              return !_.includes(
                [0, '0', '0.0', '0.00', '0.000', '0.0000'],
                v.amount
              );
            }
          );
        }
        this.detail = data;
        this.loading = false;
      } catch (err) {
        if (err.status === 412) {
          this.$Message.warning(this.$t('payroll.detail.withdrawn'));
          setTimeout(() => {
            this.modal = false;
          }, 1500);
        }
      }
    },

    //确定工资单
    async onConfirm() {
      try {
        this.sbLoading = true;
        await this.$http(
          'put',
          `mobile/payroll_confirmations/${this.detail.payrollConfirmation.id}/confirm`,
          {},
          true
        );
        this.detail.confirmedAt1 = new Date();
        this.detail.confirmedAt = new Date();
        this.$Message.success(this.$t('payroll.detail.confirm_success'));
        this.$emit('update');
        this.sbLoading = false;
      } catch (e) {
        this.sbLoading = false;
      }
    },

    //下載
    async onDownPayroll() {
      if(this.downLoading) return
      try {
       this.downLoading = true
        const {data} = await this.$http(
          "post",
          `mobile/payroll_confirmations/${this.detail.id}/download`,
          {},
          true
        );
       window.open(data)
      } finally {
        this.downLoading = false
      }
    },

    getConfirmedImg(){
      return require(`@/assets/img/confirmed_${
        this.$i18n.locale ? this.$i18n.locale : "hk"
      }.png`);
    },

    getShowSalary(key) {
      const salary = this.detail[key];
      return !this.isEye
        ? '****'
        : salary
        ? this.onToLocaleString(salary)
        : '--';
    },
    onShowEye() {
      this.isEye = !this.isEye;
      localStorage.setItem('eye', this.isEye ? '1' : '0');
    },
    onToLocaleString(value) {
      const newVal = _.toString(value).split('.');
      const digit = _.toNumber(_.head(newVal));
      const decimal = newVal.length > 1 ? `.${_.last(newVal)}` : '';
      return `${digit.toLocaleString()}${decimal}`;
    }
  }
};
</script>

<style scoped lang="less">
.payroll {
  &-header {
    margin: 24px 12px 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      flex: 1;
      font-weight: 500;
      font-size: 16px;
      color: #1f2329;
    }

    &-action{
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      .action{
        cursor: pointer;
        padding: 1px 2px;
        border-radius: 4px;
      }
      .action:hover{
        background-color: #F7F8FA;
      }
    }
  }

  &-items {
    border-radius: 4px;
    margin: 0 12px;
    height: 288px;

    .item {
      padding: 12px;
      border-bottom: 1px solid #dee0e3;
      display: flex;
      align-items: center;
      background-color: #fff;
      justify-content: space-between;
      label {
        flex: 1;
        font-weight: 400;
        font-size: 15px;
        color: #1f2329;
      }
      span {
        font-weight: 400;
        font-size: 12px;
        color: #858d99;
      }
    }
  }
}

/deep/.payroll-modal {
  .ivu-modal-content {
    background: transparent;
  }

  .ivu-modal-body {
    padding: 0 !important;
    border-radius: 12px;
  }

  &-warp {
    &-bg {
      min-height: 206px;
      position: relative;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 16px;
      background-color: #fff;

      &-row {
        min-height: 206px;
        position: relative;
        z-index: 100;

        .close-btn {
          position: absolute;
          top: 8px;
          right: 8px;
        }

        .info {
          height: 160px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #fff;
          font-size: 14px;
          font-weight: 400;
          .actualAmount {
            display: flex;
            align-items: center;
            padding-top: 6px;
            justify-content: center;
            .ivu-icon {
              cursor: pointer;
            }
          }
          .actualSalary {
            margin-bottom: 15px;
            .amount {
              font-weight: bold;
              font-size: 32px;
            }
          }
        }

        .bottom {
          display: flex;
          align-items: center;
          div {
            flex: 1;
            text-align: center;
            padding: 15px 0;
            color: #1f2329;
            font-weight: 400;
            font-size: 12px;
          }
        }
      }

      &-image {
        position: absolute;
        top: 0;
        width: 100%;

        img {
          width: 100%;
          height: 160px;
        }
      }
    }
  }

  &-content {
    padding-bottom: 6px;
  }

  .confirmed{
    &-position{
      text-align: center;
      position: absolute;
      bottom: 50px;
      right: 10px;
      width: 60px;
      height: 60px;
      align-items: center;
      align-content: center;
      display: flex;
      flex-direction: column;
    }
    &-image{
      width: 60px;
      height: 60px;
    }
  }
}

.bg-grey {
  background-color: #f2f3f5;
  border-radius: 16px;
}
.payroll-footer {
  position: fixed;
  width: 375px;
  &-box {
    padding: 8px 16px;
    border-radius: 0 0 16px 16px;

    background-color: #fff;
  }
}
</style>
